import React, { useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Grid,
  GridItem,
  Button,
  Checkbox,
  Divider,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { CorporateRefereeFormSchema } from "../utils/formValidationSchema";
// import { setloadTost } from "../redux/slices/toastSlice";
import { fetchEntryQualificationType } from "../redux/slices/entryQualificationTypeSlice";

const CorporateSponsorForm = ({ handlePrevious, handleNext }) => {
  const dispatch = useDispatch();

  // const [setUploadedFileName] = useState("");
  // const [uploadedFileName2, setUploadedFileName2] = useState("");
  // const qualificationTypeData = useSelector(
  //   (state) => state?.entryQualificationType?.entryQualificationType?.data
  // );
  useEffect(() => {
    dispatch(fetchEntryQualificationType());
  }, [dispatch]);

  const initialValues = {
    refereeInfo: {
      membershipId: "",
      fullName: "",
      email: "",
      phoneNumber: "",
      qualification: "",
      jobTitle: "",
    },
    // dataProtectionCertify: false,
    // receiveInformation: false,
  };

  const handleQualificationType = async (values) => {
    handleNext(values);
  };

  return (
    <Box>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={CorporateRefereeFormSchema}
        onSubmit={(values) => handleQualificationType(values)}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <Form style={{ width: "100%" }}>
            <Box px={"40px"}>
              <Text fontSize={"20px"} fontWeight={"700"}>
                Kindly provide your sponsor's details below
              </Text>
              <Text mt={3} mb={5} fontSize={"16px"} fontWeight={"400"}>
                Please read the notes carefully before completing this form
              </Text>
              <Grid templateColumns={"repeat(2, 1fr)"} gap={6}>
                <GridItem>
                  <FormControl
                    isInvalid={
                      errors.refereeInfo?.fullName &&
                      touched.refereeInfo?.fullName
                    }
                  >
                    <FormLabel>
                      Full Name<span style={{ color: "#D11A2A" }}>*</span>
                    </FormLabel>
                    <Input
                      name="refereeInfo.fullName"
                      placeholder="Enter Full Name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.refereeInfo.fullName}
                    />
                    <FormErrorMessage>
                      {errors.refereeInfo?.fullName}
                    </FormErrorMessage>
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl
                    isInvalid={
                      errors.refereeInfo?.email && touched.refereeInfo?.email
                    }
                  >
                    <FormLabel>
                      Email<span style={{ color: "#D11A2A" }}>*</span>
                    </FormLabel>
                    <Input
                      name="refereeInfo.email"
                      type="email"
                      placeholder="Enter Email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.refereeInfo.email}
                    />
                    <FormErrorMessage>
                      {errors.refereeInfo?.email}
                    </FormErrorMessage>
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl
                    isInvalid={
                      errors.refereeInfo?.phoneNumber &&
                      touched.refereeInfo?.phoneNumber
                    }
                  >
                    <FormLabel>
                      Phone Number<span style={{ color: "#D11A2A" }}>*</span>
                    </FormLabel>
                    <Input
                      name="refereeInfo.phoneNumber"
                      placeholder="Enter Phone Number"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.refereeInfo.phoneNumber}
                    />
                    <FormErrorMessage>
                      {errors.refereeInfo?.phoneNumber}
                    </FormErrorMessage>
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl
                    isInvalid={
                      errors.refereeInfo?.membershipId &&
                      touched.refereeInfo?.membershipId
                    }
                  >
                    <FormLabel>Membership ID</FormLabel>
                    <Input
                      name="refereeInfo.membershipId"
                      placeholder="Enter Membership ID"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.refereeInfo.membershipId}
                    />
                    <FormErrorMessage>
                      {errors.refereeInfo?.membershipId}
                    </FormErrorMessage>
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl
                    isInvalid={
                      errors.refereeInfo?.qualification &&
                      touched.refereeInfo?.qualification
                    }
                  >
                    <FormLabel>
                      Qualification<span style={{ color: "#D11A2A" }}>*</span>
                    </FormLabel>
                    <Select
                      name="refereeInfo.qualification"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.refereeInfo.qualification}
                    >
                      <option value="PhD">PhD</option>
                      <option value="Masters">Masters</option>
                      <option value="MSc">MSc</option>
                      <option value="Others">Others</option>
                    </Select>
                    <FormErrorMessage>
                      {errors.refereeInfo?.qualification}
                    </FormErrorMessage>
                  </FormControl>
                </GridItem>
              </Grid>
            </Box>
            <Divider border={"1px solid #D3D3D3"} my={10} />
            <Flex
              flexDirection={"column"}
              gap={2}
              mt={10}
              mb={5}
              fontWeight={"400"}
              fontSize={"16px"}
              lineHeight={"18.75px"}
              fontFamily={"roboto"}
              px={["30px", "40px", "40px", "50px"]}
            >
              <Text
                mb={5}
                color={"#121212"}
                fontFamily={"roboto"}
                fontSize={"20px"}
                fontWeight={"700"}
                lineHeight={"21px"}
              >
                Data Protection
              </Text>
              <FormControl
                isInvalid={
                  touched.dataProtectionCertify && errors.dataProtectionCertify
                }
              >
                <Checkbox
                  colorScheme="green"
                  isChecked={values.dataProtectionCertify}
                  onChange={(e) =>
                    setFieldValue("dataProtectionCertify", e.target.checked)
                  }
                >
                  I certify that the information given above is, to the best of
                  my knowledge, accurate in all respects. I have read and
                  accepted the regulations, terms and conditions for NCS
                  students.
                </Checkbox>
                <FormErrorMessage>
                  {errors.dataProtectionCertify}
                </FormErrorMessage>
              </FormControl>
              <Checkbox
                colorScheme="green"
                isChecked={values.receiveInformation}
                onChange={(e) =>
                  setFieldValue("receiveInformation", e.target.checked)
                }
              >
                The institute occasionally supplies mailing lists, on a
                restricted basis, to other approved organisations. If you prefer
                not to receive information by direct mail by those to whom we
                supply these lists, then please tick the box.
              </Checkbox>
            </Flex>
            <Flex justifyContent="space-between" px={"40px"} mt={10}>
              <Button onClick={handlePrevious}>Back</Button>
              <Button type="submit" colorScheme="teal">
                Next
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default CorporateSponsorForm;
